import * as React from "react";
import {Grid} from "tabler-react";
import SiteWrapper from "../../SiteWrapper.react";
import Catalogo from "../../components/Catalogo";
import {UsuariosForm}  from "../../Catalogos";
import { GetRoles } from "../../herramientas/JWT";

function UsuarioPage() {
  if(!GetRoles().includes("root",))
    window.history.back();
  return (
    <SiteWrapper>
      <Grid.Col sm={12} lg={12}>
      <Catalogo
            titulo="Usuario"
            tamanio="65%"
            FCtlogo= { UsuariosForm }
            catalogo= "usuarios"
            columnas= {
              [
                { columna: "id", label:"ID" },
                { columna: "nombre", label:"NOMBRE" },
                { columna: "apellidos", label:"APELLIDOS" },
                { columna: "username", label:"USERNAME" },
                { columna: "estatus", label:"ESTATUS" },
                { columna: "token", label: "STATIC_TOKEN"}
              ]
            }
          />
      </Grid.Col>
    </SiteWrapper>
  );
}
export default UsuarioPage;
